import React from 'react';

import styled from '@emotion/styled';
import Label from '../atoms/label';

export default class LabelGroup extends React.Component {
  render() {
    const Container = styled.span`
      display: flex;
      & > * {
        & + * {
          margin-left: 5px;
        }
      }
    `;
    return (
      <Container>
        {this.props.labels.map((item, index) => (
          <Label key={index}>{item}</Label>
        ))}
      </Container>
    );
  }
}
